import { httpPatch } from './apiService';
import { Section } from '@models/section';
import { EntityAdminApiService } from './entityAdminApiService';
import { Page } from '@models/page';

export class SectionAdminService extends EntityAdminApiService<Section> {
    public constructor() {
        super('/api/admin/section');
    }

    public updatePageSections(currentPage: Page): Promise<void | Response> {
        return httpPatch(
            `${this.baseUrl}/SavePageUpdate`,
            JSON.stringify({ pageId: currentPage.id, sections: currentPage.sections })
        ).catch((error) => {
            console.error(error);
        });
    }
}
